const TableSortDirective = function () {

    // Template shown if the header is sortable.
    const sortableColumnHeaderTemplate =
        '<a href="#" ng-click="sort($event)" ng-if="isSortable()">' +
        '    <ng-transclude></ng-transclude>' +
        '    <sub class="material-icons">{{icon()}}</sub>' +
        '</a>'

    // Template shown if the header is not sortable.  The click handler is not present.
    // This template is still an anchor element, and still includes the nested subscript
    // element (and associated CSS class), to match the style and layout of the sortable
    // template above.
    const nonSortableColumnHeaderTemplate =
        '<a ng-if="!isSortable()">' +
        '    <ng-transclude></ng-transclude>' +
        '    <sub class="material-icons"/>' +
        '</a>'

    const template = sortableColumnHeaderTemplate + nonSortableColumnHeaderTemplate;

    return {
        scope: {
            params: '=params'
        },

        transclude: true,

        template: template,

        replace: false,

        link: function (scope, element, attrs) {

            var field = attrs.field + " ";
            var up = false;

            function setUp() {
                up = true;
                scope.params.$orderby = field + "asc";
            }

            function setDown() {
                up = false;
                scope.params.$orderby = field + "desc";
            }

            scope.icon = function () {
                var index = !scope.params || !attrs.field
                    ? -1
                    : scope.params.$orderby.indexOf(field);

                if (index < 0) {
                    return "";
                } else if (up) {
                    return "arrow_drop_up"
                } else {
                    return "arrow_drop_down";
                }
            }

            scope.sort = function (event) {
                event.preventDefault();

                event.stopPropagation();

                if (!attrs.field || !scope.params) return;

                if (scope.params.$orderby && scope.params.$orderby.indexOf(field) > -1) {

                    if (scope.params.$orderby.indexOf(" desc") > -1) {
                        setUp();
                    } else {
                        setDown();
                    }
                } else {
                    setDown();
                }
            };

            scope.isSortable = function () {
                return !!attrs.field;
            }
        }
    }
};

export { TableSortDirective };